export const environment = {
  production: false,
  baseUrl: 'https://glory.upnow.com/api',
  oauthUrl: 'https://glory.upnow.com/oauth/v2',
  oauthClientId: '3c31a065-1e32-46d6-997d-c07aeb749dcf',
  oauthClientSecret: '2a29b9197e554767ab91d4efc50ca8a782740eabb1d149c5a9d2ac223efcae1c'
};
